import { render, staticRenderFns } from "./ContactsOrganization.vue?vue&type=template&id=2c08c2ce&scoped=true"
import script from "./ContactsOrganization.vue?vue&type=script&lang=js"
export * from "./ContactsOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08c2ce",
  null
  
)

export default component.exports